import { USER_AGENT } from '@trip-ux/constants';

export const isIE = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = navigator;
    const ie11orOlder = userAgent.indexOf(USER_AGENT.MSIE) >= 0 || userAgent.indexOf(USER_AGENT.TRIDENT) >= 0;
    if (ie11orOlder) {
      return true;
    }
  }
  return false;
};
export const isChrome = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = navigator;
    if (userAgent.indexOf(USER_AGENT.CHROME) >= 0) {
      return true;
    }
  }
  return false;
};

export const isFirefox = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = navigator;
    if (userAgent.indexOf(USER_AGENT.FIREFOX) >= 0) {
      return true;
    }
  }
  return false;
};

export const isIosOrAndroid = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = navigator;
    if (
      userAgent.indexOf(USER_AGENT.IPHONE) >= 0 ||
      userAgent.indexOf(USER_AGENT.IPAD) >= 0 ||
      userAgent.indexOf(USER_AGENT.ANDROID) >= 0
    ) {
      return true;
    }
  }
  return false;
};

export const isMobilePlatform = () => {
  if (typeof window !== 'undefined') {
    const { platform } = navigator;
    return !!platform && platform.match(USER_AGENT.MOBILE);
  }
  return false;
};
